import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  weAreSorryKustom: new analytics.Event({
    name: 'We Are Sorry Kustom',
    description: 'Merchant ended sign up flow in the Kustom we-are-sorry page: no products to show',
    action: analytics.EVENT_ACTION.UNKNOWN,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: ['email', 'website', 'country', 'platform', 'annualRevenue'],
  }),
};
